import { tv } from 'tailwind-variants';

export const videoCarouselVariants = tv({
  slots: {
    slideContent: ['relative', 'w-full', 'aspect-[16/9]', 'overflow-hidden'],
    slideCtaWrapper: ['mt-2', 'pointer-events-auto'],
    thumbsWrapper: ['hidden md:block'],
    thumbContainer: ['w-full h-full'],
    thumbDetails: [
      'h-auto',
      'flex items-center justify-center',
      'text-[18px] font-light text-light-black leading-[27px]',
      'p-4 pb-8',
    ],
  },
});
